<script lang="ts">
/**
 * @deprecated Use h1-h4 tag directly
 */
export default {};
</script>
<script setup lang="ts">
defineProps<{
	tag: "p" | "h1" | "h2" | "h3" | "h4" | "code";
	noTruncate?: boolean;
}>();
</script>

<template>
	<component :is="tag" :class="!noTruncate ? 'truncate' : ''">
		<slot />
	</component>
</template>
